export function getFileListItemKey(file, index) {
  return `file-${file.id || file.name}-${index}`
}
